export default __webpack_public_path__ + "static/media/FSM.c6e0a43f.svg";